/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

function isUserDTOMember(userDTO) {
    return !!(userDTO && userDTO.membershipInfoDTO && userDTO.membershipInfoDTO.membershipDTO);
}

module.exports = {
    isUserDTOMember: isUserDTOMember,
};
